module.exports = __webpack_public_path__ + "img/localadventures-payments-usd-white.8b11cbe.svg";